import {Entity} from '../../../components/entity';

export class ManufacturingCategory extends Entity {
  name: string;

  constructor({ id, name, createdAt, updatedAt }: Partial<ManufacturingCategory>) {
    super({ id, createdAt, updatedAt });
    this.name = name ?? '';
  }

  getNameProperty(): string {
    return 'name';
  }
}
